import { render, staticRenderFns } from "./heading_with_content.vue?vue&type=template&id=e319d52e&scoped=true&"
import script from "./heading_with_content.vue?vue&type=script&lang=js&"
export * from "./heading_with_content.vue?vue&type=script&lang=js&"
import style0 from "./heading_with_content.vue?vue&type=style&index=0&id=e319d52e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e319d52e",
  null
  
)

export default component.exports